"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
const personne_1 = require("views/personne");
const entreprise_1 = require("views/entreprise");
const aide_1 = require("views/aide");
const assistance_1 = require("./assistance");
class PGILayout extends webix_jet_1.JetView {
    config() {
        let bandeau = {
            "cols": [
                { view: "button", type: "image",
                    image: globals_1.phpPath + "img/miniLogo.jpg",
                    label: "", width: 60, tooltip: (0, globals_1._)("Retour à l'accueil"),
                    click: () => this.getStart()
                },
                { view: "button",
                    label: "Organisation", width: 200,
                    id: "organisationButton", tooltip: (0, globals_1._)("Données d'entreprise"),
                    click: () => this.getEntreprise()
                },
                { label: "Label", height: 0 },
                { view: "button", css: "app_menu", layout: "x", select: true, id: "myDataButton",
                    type: "icon", icon: "mdi mdi-account-details-outline", tooltip: (0, globals_1._)("Gérer mon compte"),
                    label: (0, globals_1._)("Mon compte"), maxWidth: 150,
                    click: () => this.getPersonne() },
                { view: "button", css: "app_menu", layout: "x", select: true, id: "deconnexionButton",
                    type: "icon", icon: "mdi mdi-logout", tooltip: (0, globals_1._)("Déconnexion"),
                    label: (0, globals_1._)("Déconnexion"), maxWidth: 150,
                    click: () => this.deconnexion() },
                { view: "button", css: "app_menu", layout: "x", select: true, id: "sosButton",
                    type: "icon", icon: "mdi mdi-help-circle-outline", tooltip: (0, globals_1._)("Aide"),
                    label: (0, globals_1._)("Aide"), maxWidth: 150,
                    click: () => this.sos()
                },
                { view: "button", css: "app_menu", layout: "x", select: true, id: "assistButton",
                    type: "icon", icon: "mdi mdi-account-question-outline", tooltip: (0, globals_1._)("Assistance"),
                    label: (0, globals_1._)("Assistance"), maxWidth: 150,
                    click: () => this.getAssistance(), hidden: false
                },
                { label: "Label", "view": "", "height": 0, gravity: 3 },
            ]
        };
        //  TODO scrollview, la solution suivant n'a pas fonctionné
        //  view: "scrollview",
        //   scroll: "y",
        //   body: {
        //     rows:[
        let menuGauche = {
            rows: [
                {
                    view: "toolbar", css: "webix_dark", padding: 3, id: "menuGauche",
                    elements: [
                        { view: "button", type: "icon", icon: "mdi mdi-menu",
                            width: 37, align: "left", css: "app_button",
                            click: function () {
                                const menu = $$("menu");
                                menu.toggle();
                            }
                        },
                        { view: "label", label: "Menu" }
                    ]
                }, {
                    view: "sidebar", css: "webix_dark", id: "menu",
                    width: 180,
                    scroll: "auto",
                    multipleOpen: true,
                    template: function (obj) {
                        return "<div id='" + obj.id + "'>" + obj.value + "</div>";
                    }
                }
            ]
        };
        return {
            id: "appLayout",
            type: "clean", paddingX: 5, rows: [
                // {  paddingX:5, paddingY:10, rows: [ {css:"webix_shadow_medium", rows:[header]} ]},
                bandeau,
                { type: "wide", paddingY: 10, paddingX: 5, cols: [
                        menuGauche,
                        { rows: [
                                { $subview: true },
                                // { "label": "Label", "view": "", "height": 30 },  // bandeeau du bas jamais utilisé
                            ] }
                    ] }
            ]
        };
    }
    sos() {
        if (!this.aide) {
            this.aide = this.ui(aide_1.default);
        }
        this.aide.showHelp();
        this.aide.load(this.getOptionName());
    }
    getAssistance() {
        // // @ts-ignore
        // let a = this.ui(Assistance) as Assistance;
        // a.showWindow();
        // a.load(this.getOptionName());
        if (!this.assistance) {
            this.assistance = this.ui(assistance_1.default);
        }
        this.assistance.showWindow(this.getOptionName());
    }
    getOptionName() {
        let url = window.location.href;
        let tab = url.split("/");
        let option = tab[tab.length - 1];
        return option.charAt(0).toUpperCase() + option.slice(1);
        // webix.message(optionMenu);
    }
    getPersonne() {
        // @ts-ignore
        this.ui(personne_1.default).showWindow();
    }
    getEntreprise() {
        // @ts-ignore
        this.ui(entreprise_1.default).showWindow();
    }
    getStart() {
        window.location.href = "#!/pgiLayout/start";
        let menuGauche = $$("menu");
        menuGauche.unselectAll();
    }
    deconnexion() {
        window.clearInterval(globals_1.lv2.intervalID);
        webix.message("Déconnexion");
        this.saveUserPreferences();
        // @ts-ignore
        webix.ajax().post(globals_1.phpPath + "login.php?option=logout").then(function () {
            window.location.href = "#!/login";
        });
    }
    init() {
        // TEST d'un editeur valeur < 100
        // @ts-ignore
        webix.editors.pourcentage = webix.extend({
            render: function () {
                return webix.html.create("div", {
                    "class": "webix_dt_editor"
                }, "<input type='email'>");
            }
        }, webix.editors.text);
        // vérifier que nous sommes toujours connectés (pas de retour arrière après une déconnexion)
        globals_1.lv2.trace("vérifier que nous sommes toujours connectés (pas de retour arrière après une déconnexion)");
        // @ts-ignore
        webix.ajax(globals_1.phpPath + "login.php?option=status").then(function (data) {
            if (data.json().status === "error") {
                webix.alert({
                    text: (0, globals_1._)("Connexion non valide"),
                }).then(function () {
                    window.location.href = "#!/login";
                });
            }
        });
        const menu = $$("menu");
        menu.load(globals_1.phpPath + "droits.php?option=menu");
        let oButton = $$("organisationButton");
        // @ts-ignore
        webix.ajax(globals_1.phpPath + "parametres.php?key=organisation.data&option=readjson").then(function (data) {
            let vv = data.json().nom;
            oButton.define("label", vv);
            oButton.refresh();
        });
        // chargement des paramètres relatifs à l'interface utilisateur
        let vvv = webix.ajax().sync().get(globals_1.phpPath + "parametres.php?key=ihm.data&option=readjson");
        globals_1.lv2.ihm = JSON.parse(vvv.responseText);
        // lecture des droits de l'utilisateur
        // @ts-ignore
        let xhr = webix.ajax().sync().get(globals_1.phpPath + "droits.php?option=droits");
        // @ts-ignore
        globals_1.lv2.droits = JSON.parse(xhr.responseText);
        this.use(webix_jet_1.plugins.Menu, "menu");
        let me = this;
        // parametrer l'intervalle de contrôle d'activité intervallecheck
        // @ts-ignore
        webix.ajax(globals_1.phpPath + "parametres.php?option=read&key=intervallecheck").then(function (data) {
            let intervalle = data.json().valeur;
            if (intervalle > 0) {
                globals_1.lv2.intervalID = setInterval(me.checkServer, intervalle * 1000);
            }
        });
        // lecture des préférences utilisateur
        // @ts-ignore
        xhr = webix.ajax().sync().get(globals_1.phpPath + "utilisateurs.php?option=readPrefs");
        // @ts-ignore
        globals_1.lv2.userPrefs = JSON.parse(xhr.responseText);
        globals_1.lv2.userPrefs.dirty = false;
        globals_1.lv2.numberFormat = {
            edit: function (v) { return webix.Number.format(v, webix.i18n); },
            parse: function (v) {
                if (v == null)
                    return "";
                return webix.Number.parse(v, webix.i18n);
            }
        };
        if ((globals_1.lv2.droits).includes("assistance.bouton")) {
            $$("assistButton").show();
        }
    }
    checkServer() {
        let me = this;
        let vv = globals_1.phpPath + "login.php?option=status";
        // @ts-ignore
        webix.ajax().get(vv).then(function (data) {
            if (!data.json().success) {
                window.clearInterval(globals_1.lv2.intervalID);
                webix.alert(data.json().response);
                window.location.href = "#!/login";
            }
            else {
                me.saveUserPreferences();
            }
        });
    }
    saveUserPreferences() {
        if ("dirty" in globals_1.lv2.userPrefs) {
            if (globals_1.lv2.userPrefs["dirty"]) {
                let vv = JSON.stringify(globals_1.lv2.userPrefs);
                let xx = { "data": vv };
                // @ts-ignore
                webix.ajax().post(globals_1.phpPath + "utilisateurs.php?option=updatePrefs", xx);
                globals_1.lv2.userPrefs.dirty = false;
                globals_1.lv2.trace("Préférences utilisateur enregistrées.");
            }
        }
    }
}
exports.default = PGILayout;
